import { HttpErrorResponse } from '@angular/common/http';
import { ApiExceptionConstructor } from 'src/core/common/domain/exceptions/api-exception';
import { ConnectionException } from 'src/core/common/domain/exceptions/connection-exception';

export class TimeoutException extends ConnectionException implements ApiExceptionConstructor {
  constructor(message?: string, error?: HttpErrorResponse | Error) {
    super(message, error);
    this.name = 'TimeoutException';
  }

  static fromError(error: HttpErrorResponse | Error): TimeoutException {
    return new this(error.message, error);
  }
}
